import Vue from 'vue';
import Util from 'src/utils/general';
import copy from 'copy-to-clipboard';
const SENTIMENT_STYLE = {
    positive: 'sentiment-positive',
    negative: 'sentiment-negative',
    mixed: 'sentiment-mixed'
};
export default Vue.extend({
    name: 'Verbatim',
    props: {
        highlightedText: { type: String, required: true },
        rawText: { type: String, required: true },
        structuredData: { type: Array, required: false, default: () => ([]) },
        showAnnotations: { type: Boolean, default: false },
        groupByField: { type: String, required: false, default: null }
    },
    data() {
        return {
            /** When expanded, the widget shows the full text instead of the truncated version. */
            expanded: false,
            /** When showing the info, the structured data is displayed in the widget */
            showInfo: false,
            TRUNCATE_AT: 1000,
        };
    },
    computed: {
        sentiment() {
            let hit = this.structuredData.find(x => x.field === 'Sentiment');
            return hit?.value;
        },
        sentimentStyle() {
            return SENTIMENT_STYLE[this.sentiment];
        },
        groupByValue() {
            if (!this.groupByField) {
                return null;
            }
            return this.structuredData.find(x => x.field === this.groupByField).value;
        }
    },
    methods: {
        truncateText: Util.truncateText,
        copy: copy,
        toggleShowInfo() {
            this.showInfo = !this.showInfo;
            if (this.showInfo) {
                this.$analytics.track.verbatimsWidget.showInfo(true);
            }
        },
    }
});
